import React from 'react';
import Text from '../Text';
import { StyleSheet, css } from 'aphrodite/no-important';

const s = StyleSheet.create({
  error: {
    color: 'red',
    fontSize: 12,
    padding: '5px 0',
  },
});

const Error = (props) => <Text {...props} className={css(s.error)} />;

export default Error;
